import React from 'react';
import {
    ChartBarIcon,
    ChartPieIcon,
    UserGroupIcon,
} from '@heroicons/react/20/solid';
import gameLineAnalysis from '@assets/images/screenshots/GameLineAnalysis.png';

const features = [
    {
        name: 'Game Line Analysis',
        description: 'View team performance across multiple splits (L5, L10, L15, L20, L30). Analyze scoring by game period for moneyline trends, combine team totals by period, and evaluate spread performance to identify consistent patterns.',
        icon: ChartBarIcon,
    },
    {
        name: 'Matchup Stats',
        description: 'Compare team statistics with multiple normalization methods including raw averages, z-score, league rank, percentile, and min-max scaling. Visualize key matchup metrics with clean radar charts for instant insights.',
        icon: ChartPieIcon,
    },
    {
        name: 'Player Stats',
        description: 'Access comprehensive season statistics for any player and dive into their last 10 game logs. Track individual stat trends over time to identify hot streaks, slumps, and performance patterns.',
        icon: UserGroupIcon,
    },
];

export const GameAnalysisFeature = () => {
    return (
        <div className="bg-white dark:bg-brand-dark-900 py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-2xl sm:text-center">
                    <h2 className="text-base/7 font-semibold text-brand-red-500 dark:text-brand-red-400">Game Analysis Tools</h2>
                    <p className="mt-2 text-4xl font-semibold tracking-tight text-gray-900 dark:text-white sm:text-5xl sm:text-balance">
                        Deep Dive Into Every Matchup
                    </p>
                    <p className="mt-6 text-lg/8 text-gray-600 dark:text-gray-400">
                        Analyze games from every angle with comprehensive statistics, flexible time splits, and advanced visualization tools. 
                        Get the complete picture before placing your bets.
                    </p>
                </div>
            </div>
            <div className="relative overflow-hidden pt-16">
                <div className="mx-auto max-w-7xl px-6 lg:px-8">
                    <img
                        src={gameLineAnalysis}
                        alt="Game Line Analysis Dashboard"
                        className="mb-[-12%] rounded-xl shadow-2xl ring-1 ring-gray-900/10 dark:ring-white/10"
                    />
                    <div aria-hidden="true" className="relative">
                        <div className="absolute -inset-x-20 bottom-0 bg-gradient-to-t from-white dark:from-brand-dark-900 pt-[7%]" />
                    </div>
                </div>
            </div>
            <div className="mx-auto mt-16 max-w-7xl px-6 sm:mt-20 md:mt-24 lg:px-8">
                <dl className="mx-auto grid max-w-2xl grid-cols-1 gap-x-6 gap-y-10 text-base/7 text-gray-600 dark:text-gray-400 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3 lg:gap-x-8 lg:gap-y-16">
                    {features.map((feature) => (
                        <div key={feature.name} className="relative pl-9">
                            <dt className="inline font-semibold text-gray-900 dark:text-white">
                                <feature.icon 
                                    aria-hidden="true" 
                                    className="absolute top-1 left-1 size-5 text-brand-red-500 dark:text-brand-red-400" 
                                />
                                {feature.name}
                            </dt>{' '}
                            <dd className="inline">{feature.description}</dd>
                        </div>
                    ))}
                </dl>
            </div>
        </div>
    );
};

